@if (notice) {
  <aside class="non-production-banner" role="alert" data-testid="non-production-banner">
    <p class="non-production-banner__title">{{ notice.title }}</p>
    <p class="non-production-banner__body">{{ notice.body }}</p>
  </aside>
}
